import { render, staticRenderFns } from "./Licensing.vue?vue&type=template&id=0ebccd2c&"
import script from "./Licensing.vue?vue&type=script&lang=js&"
export * from "./Licensing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports